module.exports = __webpack_public_path__ + "img/thumb_32.3ab769ba.jpg";